<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="salesOrders"
      class="elevation-1"
      :loading="isLoading"
      sort-by="salesOrder"
      sort-desc
    >
      <template v-slot:item.validation="{ item }">
        <v-icon v-if="isValid(item)" color="green">
          {{ mdiCheckCircle }}
        </v-icon>
        <v-icon v-else color="error">
          {{ mdiAlertCircle }}
        </v-icon>
      </template>
      <template v-slot:item.orderDate="{ item }">
        {{ formatDate(item.orderDate) }}
      </template>
      <template v-slot:item.deliveryDate="{ item }">
        {{ formatDate(item.deliveryDate) }}
      </template>
      <template v-slot:item.printCount="{ item }">
        {{ item.printCount + 1 }}
      </template>
      <template v-slot:item.orderTotalIncVat="{ item }">
        <span v-if="item.orderTotalIncVat">
          R {{ formatCurrency(item.orderTotalIncVat) }}
        </span>
        <span v-else>
          -
        </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import {
  mdiDelete, mdiPencil, mdiCheckCircle, mdiAlertCircle,
} from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListOrder',
  module: 'Orders',
  mixins: [loading],
  data() {
    return {
      mdiDelete,
      mdiPencil,
      mdiCheckCircle,
      mdiAlertCircle,
      salesOrders: [],
      history: [{
        text: 'Home',
        disabled: false,
        href: '/#/members',
        depth: 0,
      }, {
        text: 'Sales Orders',
        disabled: true,
        depth: 0,
      }],
    };
  },
  computed: {
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: '',
          value: 'validation',
        },
        {
          text: 'Sales Order No',
          value: 'salesOrder',
        },
        {
          text: this.$$t('status'),
          value: 'status',
        },
        {
          text: this.$$t('customerName'),
          value: 'customerName',
        },
        {
          text: this.$$t('orderDate'),
          value: 'orderDate',
        },
        {
          text: this.$$t('version'),
          value: 'printCount',
        },
        {
          text: 'Sales Order Total',
          value: 'salesOrderValue',
        },
        {
          text: 'Sales Order Lines',
          value: 'salesOrderLineCount',
        },
        {
          text: 'Back Order Lines',
          value: 'salesOrderLineCountBackOrdered',
        },
        {
          text: this.$$t('invoiceNo'),
          value: 'invoice',
        },
        {
          text: this.$$t('invoiceAmount'),
          value: 'invoiceValue',
        },
        {
          text: 'Invoices Lines',
          value: 'invoiceLineCount',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.refresh();
    this.isLoading = false;
    this.SET_title('Sales Orders');
  },
  methods: {
    /** Vuex methods
     */
    ...mapMutations('app', ['SET_title', 'SET_expandedSearch']),
    async refresh() {
      const start = new Date();
      start.setMonth(start.getMonth() - 1);
      const end = new Date();
      end.setDate(end.getDate() + 1);
      const url = `odata/salesOrders/GetRecon?start=${this.formatDate(start)}&end=${this.formatDate(end)}`;
      const { data } = await this.$http.get(url);
      this.salesOrders = data.value;
    },
    isValid(item) {
      if (!item.invoiceValue || !item.salesOrderValue) {
        return false;
      }
      return item.invoiceValue === item.salesOrderValue;
    },
  },
};
</script>

<docs>
# Category example

'''js
<Category />
'''
</docs>
